// extracted by mini-css-extract-plugin
module.exports = {"transaction__list":"Transaction_transaction__list__3UGjo","transaction-empty":"Transaction_transaction-empty__2Lva9"};